<div class="toggle-container" [class.disabled]="disabled" [class]="size">
  @for (option of options; track option) {
    <button
      id="tabs-buttons-{{ option.replaceAll(' ', '-') }}"
      class="toggle-option {{
        currentOption ? (currentOption === option ? background : '') : defaultOption === option ? background : ''
      }}
          {{ icon ? 'toogle-option-icon' : '' }}"
      [class.selected]="currentOption ? currentOption === option : defaultOption === option"
      (click)="onToggle(option)"
      [disabled]="disabled"
    >
      @if (!icon) {
        <ng-container>
          {{ option }}
        </ng-container>
      } @else if (option !== '') {
        <app-icon [phosphorClass]="option" [iconStyle]="Style.bold" [size]="Size['medium-small']" [color]="Color.white">
        </app-icon>
      }
    </button>
  }
</div>
